import { OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AssetManagementObject, FuelType, VehicleStatus } from 'app/interfaces/asset-management/asset-management-object.interface';
import { LinkedAssetResource, LinkedAssetRole, LinkedResourceRole, ServiceInformation } from 'app/interfaces/journey-management/journey-management-object.interface';
import { UserDetail } from 'app/interfaces/user.interface';

import * as short from 'short-uuid';
import { ItemTypeEnum, BookingManagementObject } from 'app/interfaces/booking-management/booking-management-object.interface';
import { ConfirmationDialogComponent } from 'app/pages/Common/confirmation-dialog.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatStepper } from '@angular/material/stepper';
import { FormControl } from '@angular/forms';
interface HasKey {
    key?: string;
}

@Component({
    selector: 'app-admin-dashboard-journey-management-assignment-dialog',
    templateUrl: './admin-dashboard-journey-management-assignment-dialog.component.html',
    styleUrls: [
        './admin-dashboard-journey-management-assignment-dialog.component.css'
    ],
    encapsulation: ViewEncapsulation.None,
})
export class AdminDashboardJourneyManagementAssignmentDialogComponent implements OnInit {
    @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sort = new QueryList<MatSort>();
    @ViewChild('stepper')  stepper: MatStepper;
    
    totalLength: number = 10000;
    pageSize: number = 5;
    pageSizeOptions: number[] = [5, 10, 25, 100];

    resourceObjects: MatTableDataSource<UserDetail> = new MatTableDataSource<UserDetail>([]);
    resourceColumns: string[] = [
        'selected',
        'name', 
        'msisdn',
        'state',
        'appVersion', 
        'role',
        'info',
    ];
    resourceRoles = [] //Now dynamic from selected cleint in JM;
    selectedResources: UserDetail[] = [];
    resourceRoleSelections: { [resourceKey: string]: string} = {};

    assetObjects: MatTableDataSource<AssetManagementObject> = new MatTableDataSource<AssetManagementObject>([]);
    assetColumns: string[] = [
        'selected',
        'vehicleType',
        'registrationNumber',
        'state',
        'resources',
        'role',
        'info',
    ];
    assetRoles = []//Now dynamic from selected cleint in JM;
    selectedAssets: AssetManagementObject[] = [];
    assetRoleSelections: { [assetKey: string]: string } = {};
    AssetResourceMutipleSelection = new FormControl('');



    assetResourceAssignments: { [assetKey: string]: UserDetail[] } = {};



    additionalNotes: string;
    autoDispatch: boolean;
    autoDispatchTime: number = 0;

    isLinear = true;
    canSave: boolean = false;

    selectedResourceKeys: Set<string> = new Set();
    selectedAssetKeys: Set<string> = new Set();

    extraConfirmation: boolean = false;

    requiredResourcesMet: boolean = true;
    requiredAssetsMet: boolean = true;

    constructor(private dialogRef: MatDialogRef<AdminDashboardJourneyManagementAssignmentDialogComponent>, private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: { serviceInformation: ServiceInformation, availableResources: UserDetail[], availableAssets: AssetManagementObject[], existingBookings: BookingManagementObject[], resourceRoles: string[],assetRoles: string[],rental:boolean }) { }

    ngOnInit() {
        this.resourceRoles = this.data.resourceRoles || [];
        this.assetRoles = this.data.assetRoles || [];
        if (this.data && this.data.serviceInformation.linkedAssetsResources) {
            this.populateLinkedAssetResources(this.data.serviceInformation.linkedAssetsResources);
            this.additionalNotes = this.data.serviceInformation.additionalNotes;
            this.autoDispatch = this.data.serviceInformation.autoDispatch ? this.data.serviceInformation.autoDispatch : false;
            this.autoDispatchTime = this.data.serviceInformation.autoDispatchTime ? this.data.serviceInformation.autoDispatchTime : 0;
        }

        //Filter Prediecates - 1: Resources
        this.resourceObjects.filterPredicate = (data: UserDetail, filter: string) => {
            let concatenatedFields = data.firstName || '' + data.lastName || '';    
            return concatenatedFields.toLowerCase().includes(filter.trim().toLowerCase());
        };  

        this.assetObjects.filterPredicate = (data: AssetManagementObject,filter: string) => {
            let concatenatedFields = data.registrationNumber || '' + data.make || '' + data.model;    
            return concatenatedFields.toLowerCase().includes(filter.trim().toLowerCase());
        }
    }

    ngAfterViewInit() {
        this.resourceObjects.data = this.data.availableResources;
        this.resourceObjects.paginator = this.paginator.toArray()[0];
        this.resourceObjects.sort = this.sort.toArray()[0];

        this.assetObjects.data = this.data.availableAssets;
        this.assetObjects.paginator = this.paginator.toArray()[1];
        this.assetObjects.sort = this.sort.toArray()[1];
    }

    goBack(stepper: MatStepper){
        stepper.previous();
    }
    
    goForward(stepper: MatStepper){
        stepper.next();
    }

    //MARK: Resource Filter Fucntions
    applyServiceInformationObjectFilter(filterValue: string) {
        this.resourceObjects.filter = filterValue.trim().toLowerCase();
        this.resourceObjects.paginator = this.paginator.toArray()[0];
    }

    applyAssetInformationObjectFilter(filterValue: string) {
        this.assetObjects.filter = filterValue.trim().toLowerCase();
        this.assetObjects.paginator = this.paginator.toArray()[1];
    }

    addRentalAsset() {
        this.assetObjects.data.push({
            key: short.uuid(),
            vehicleType:'Rental',
            registrationNumber: 'unknown',
            capacity: 2,
            fuelType: FuelType.Unknown,
            make: 'Rental',
            model: 'Vehicle',
            state: VehicleStatus.Rental,
        })
        this.assetObjects.data = this.assetObjects.data;
    }

    private populateLinkedAssetResources(linkedAssetResources: LinkedAssetResource[]): void {
        this.isLinear = false;

        for (const linkedAssetResource of linkedAssetResources) {
            if (linkedAssetResource.asset) {
                this.selectedAssets.push(linkedAssetResource.asset.asset);
                this.selectedAssetKeys.add(linkedAssetResource.asset.asset.key);
                this.assetRoleSelections[linkedAssetResource.asset.asset.key] = linkedAssetResource.asset.assetRole;
            }

            linkedAssetResource.associatedResources.forEach(linkedResourceRole => {
                if (!linkedResourceRole || !linkedResourceRole.resource) {
                    return;
                }

                if (this.selectedResources.findIndex(r => r.key === linkedResourceRole.resource.key) === -1) {
                    this.selectedResources.push(linkedResourceRole.resource);
                    this.selectedResourceKeys.add(linkedResourceRole.resource.key);
                }

                this.resourceRoleSelections[linkedResourceRole.resource.key] = linkedResourceRole.resourceRole;

                if (linkedAssetResource.asset && linkedAssetResource.asset.asset) {
                    this.assetResourceAssignments[linkedAssetResource.asset.asset.key] = this.assetResourceAssignments[linkedAssetResource.asset.asset.key] || [];
                    this.assetResourceAssignments[linkedAssetResource.asset.asset.key].push(linkedResourceRole.resource);
                }
            });
        }

        this.assetKeys = Object.keys(this.assetResourceAssignments);
    }

    private toggleSelection<T extends HasKey>(items: T[], item: T, selections: { [key: string]: any }, keySet: Set<string>) {
        const index = items.findIndex(i => i.key === item.key);

        if (index !== -1) {
            items.splice(index, 1);
            keySet.delete(item.key);

            if (selections.hasOwnProperty(item.key)) {
                delete selections[item.key];
            }
        } 
        else {
            items.push(item);
            keySet.add(item.key);
        }
    }

    private isItemSelected<T extends HasKey>(keySet: Set<string>, item: T): boolean {
        return keySet.has(item.key);
    }

    toggleResourceSelection(resource: UserDetail) {
        this.toggleSelection(this.selectedResources, resource, this.resourceRoleSelections, this.selectedResourceKeys);

        if (this.assetResourceAssignments) {
            for (const assetKey in this.assetResourceAssignments) {
                this.assetResourceAssignments[assetKey] = this.assetResourceAssignments[assetKey].filter(user => user.key !== resource.key);
            }
        }

        this.assetKeys = Object.keys(this.assetResourceAssignments);
        this.validateRequirements();
    }

    isResourceSelected(resource: UserDetail): boolean {
        return this.isItemSelected(this.selectedResourceKeys, resource);
    }

    assignResourceRole(resource: UserDetail, role: string) {
        this.resourceRoleSelections[resource.key] = role;
    }

    getResourceRole(resourceKey: string): string {
        const resourceRole = this.resourceRoleSelections[resourceKey];

        return resourceRole ? resourceRole : 'Unknown Role';
    }

    getResourceSchedule(resourceKey: string): string {
        let times: string[] = [];

        this.data.existingBookings.forEach(booking => {
            if (booking.itemType === ItemTypeEnum.Resource && booking.itemKey === resourceKey) {
                times.push(booking.time);
            }
        });

        if (times.length === 0) {
            //return 'The resource is not scheduled for today.';
            return '';
        }
        else {
            const timesString = times.join(', ');
            return `This resource has been scheduled for ${times.length} job${times.length > 1 ? 's' : ''} at the following times: ${timesString}`;
        }
    }

    toggleAssetSelection(asset: AssetManagementObject) {
        this.toggleSelection(this.selectedAssets, asset, this.assetRoleSelections, this.selectedAssetKeys);

        if (this.assetResourceAssignments && this.assetResourceAssignments[asset.key]) {
            delete this.assetResourceAssignments[asset.key];
        }

        this.assetKeys = Object.keys(this.assetResourceAssignments);
        this.validateRequirements();
    }

    toggleAutoDispatch() {
        if (this.autoDispatch) {
            this.autoDispatch = false;
        } else {
            this.autoDispatch = true;
            if (this.autoDispatchTime == 0) {
                this.autoDispatchTime = 5;
            }
        } 
    }

    isAssetSelected(asset: AssetManagementObject): boolean {
        return this.isItemSelected(this.selectedAssetKeys, asset);
    }

    assignAssetRole(asset: AssetManagementObject, role: string) {
        this.assetRoleSelections[asset.key] = role;
    }

    getAssetRole(assetKey: string): string {
        const assetRole = this.assetRoleSelections[assetKey];

        return assetRole ? assetRole : 'Unknown Role';
    }

    getAssetSchedule(assetKey: string): string {
        let times: string[] = [];

        this.data.existingBookings.forEach(booking => {
            if (booking.itemType === ItemTypeEnum.Asset && booking.itemKey === assetKey) {
                times.push(booking.time);
            }
        });

        if (times.length === 0) {
            //return 'The asset is not scheduled for today.';
            return '';
        }
        else {
            const timesString = times.join(', ');
            return ` - This asset has been scheduled for ${times.length} job${times.length > 1 ? 's' : ''} at the following times: ${timesString}`;
        }
    }

    isMaxCountReached(asset: AssetManagementObject): boolean {
        if (!this.assetResourceAssignments[asset.key]) {
           return false;
        } else {
            return this.assetResourceAssignments[asset.key].length >= asset.capacity;
        }
    }

    isResourceAssignedToAsset(asset: AssetManagementObject, resource: UserDetail): boolean {
        const assignedResources = this.assetResourceAssignments[asset.key] || [];

        return assignedResources.includes(resource);
    }

    toggleAssetResourceAssignment(asset: AssetManagementObject, resource: UserDetail[]) {

        if (resource.length >= 1) {
            if (!this.assetResourceAssignments[asset.key]) {
                this.assetResourceAssignments[asset.key] = [];
            }
        
            const currentAssignmentsForAsset = this.assetResourceAssignments[asset.key].length;
            
            const isAlreadyAssignedToAsset = this.assetResourceAssignments[asset.key].includes(resource[0]);
        
            if (!isAlreadyAssignedToAsset && currentAssignmentsForAsset < asset.capacity) {
                for (const key in this.assetResourceAssignments) {
                    const index = this.assetResourceAssignments[key].findIndex(r => r === resource);
    
                    if (index !== -1) {
                        this.assetResourceAssignments[key].splice(index, 1);
                    }
                }
        
                this.assetResourceAssignments[asset.key].push(resource[0]);
            } 
            else if (isAlreadyAssignedToAsset) {
                const index = this.assetResourceAssignments[asset.key].findIndex(r => r === resource);
    
                if (index !== -1) {
                    this.assetResourceAssignments[asset.key].splice(index, 1);
                }
            }
    
            this.assetKeys = Object.keys(this.assetResourceAssignments);
        } 
    }

    isResourceAlreadyAssigned(resource: UserDetail,asset: AssetManagementObject): Boolean {
        const assets = Object.keys(this.assetResourceAssignments);
        for (const assetKey of assets) {
            if (this.assetResourceAssignments[assetKey].findIndex((assignedResource) => assignedResource.key == resource.key) != -1) {
                if (assetKey != asset.key) {
                    return true
                } 
            }
        };
        return false;
    }

    assetKeys: string[] = [];

    /* get assetKeys() {
        return Object.keys(this.assetResourceAssignments);
    } */

    getAssetName(assetKey: string): string {
        const asset = this.selectedAssets.find(a => a.key === assetKey);

        return asset ? `${asset.make} ${asset.model} ${asset.registrationNumber}` : 'Unknown Asset';
    }

    validateRequirements(): void {
        // Check if required resources are met
        const requiredResourceCount = this.data.serviceInformation.requiredResourceCount;
        if (requiredResourceCount && requiredResourceCount > 0) {
            this.requiredResourcesMet = this.selectedResources.length >= requiredResourceCount;
        } else {
            this.requiredResourcesMet = true;
        }

        // Check if required assets are met
        const requiredAssetCount = this.data.serviceInformation.requiredAssetCount;
        if (requiredAssetCount && requiredAssetCount > 0) {
            this.requiredAssetsMet = this.selectedAssets.length >= requiredAssetCount;
        } else {
            this.requiredAssetsMet = true;
        }
    }

    onStepChange(event: StepperSelectionEvent): void {
        if (event.selectedIndex === 3) {
            this.validateRequirements();
            this.canSave = this.requiredResourcesMet && this.requiredAssetsMet;
        }
        else {
            this.canSave = false;
        }
    }

    onConfirm(): void {
        const linkedAssetResources: LinkedAssetResource[] = [];

        let message: string = '';

        const allSelectedResources = new Set(this.selectedResources.map(resource => resource.key));

        for (let i = 0; i < this.selectedResources.length; i++) {
            const resource = this.selectedResources[i];

            if (!this.resourceRoleSelections[resource.key]) {
                message += 'Resource exists but no resource role is associated. ';

                break;
            }
        }
        
        this.selectedAssets.forEach(asset => {
            const assetRole: LinkedAssetRole = {
                asset: asset,
                assetRole: this.assetRoleSelections[asset.key]
            };

            if (asset && !assetRole.assetRole) {
                message += 'Asset exists but no asset role is associated. ';
            }

            const associatedResources: LinkedResourceRole[] = [];
            const assetResourceList = this.assetResourceAssignments[asset.key] || [];

            assetResourceList.forEach(resource => {
                const resourceRole: LinkedResourceRole = {
                    resource: resource,
                    resourceRole: this.resourceRoleSelections[resource.key]
                };

                if (resource && !resourceRole.resourceRole) {
                    message += 'Resource exists but no resource role is associated. ';
                }

                associatedResources.push(resourceRole);

                allSelectedResources.delete(resource.key);
            });

            if (associatedResources.length > 0 && !asset) {
                message += 'Associated resources exist but no asset is linked. ';
            }

            if (asset && associatedResources.length === 0) {
                message += 'Asset exists but no associated resources are linked. ';
            }

            linkedAssetResources.push({
                key: short.generate(),
                asset: assetRole,
                associatedResources: associatedResources
            });
        });

        if (allSelectedResources.size > 0) {
            message += 'Some resources were selected but not assigned to any assets. ';
        }

        if (message.length > 0) {
            this.extraConfirmation = true;

            message += 'Would you still like to save?';

            const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                width: '25%',
                disableClose: true,
                data: {
                    message: message
                }
            });

            dialogRef.afterClosed().subscribe(async result => {
                this.extraConfirmation = false;

                if (result) {
                    this.dialogRef.close({
                        additionalNotes: this.additionalNotes,
                        autoDispatch: this.autoDispatch,
                        autoDispatchTime: this.autoDispatchTime,
                        linkedAssetResources: linkedAssetResources
                    });
                }
            });
        }
        else {
            this.dialogRef.close({
                additionalNotes: this.additionalNotes,
                autoDispatch: this.autoDispatch,
                autoDispatchTime: this.autoDispatchTime,
                linkedAssetResources: linkedAssetResources
            });
        }
    }

    onCancel(): void {
        this.dialogRef.close();
    }
}